import { forwardRef } from 'react'

interface AudioPlayerProps {
  callId: number
  onTimeUpdate?: (sec: number) => void
  className?: string
  preload?: 'auto' | 'metadata' | 'none'
}

// <audio> element wrapped for the call-detail view. Points at the API's
// /api/calls/:id/audio stream endpoint which the Vite dev-server proxies
// to the FastAPI backend on 8400. Range requests are handled server-side.
export const AudioPlayer = forwardRef<HTMLAudioElement, AudioPlayerProps>(
  function AudioPlayer(
    { callId, onTimeUpdate, className = '', preload = 'metadata' },
    ref
  ) {
    // HTML5 <audio> cannot set custom headers, so the Bearer key is passed as
    // a query-string token. The backend `audio_router` accepts either form.
    const apiKey =
      typeof window !== 'undefined'
        ? window.localStorage.getItem('killacoach_api_key')
        : null
    const src = apiKey
      ? `/api/calls/${callId}/audio?token=${encodeURIComponent(apiKey)}`
      : `/api/calls/${callId}/audio`
    return (
      <audio
        ref={ref}
        controls
        preload={preload}
        className={`w-full ${className}`}
        src={src}
        onTimeUpdate={(e) => {
          onTimeUpdate?.((e.target as HTMLAudioElement).currentTime)
        }}
      >
        <source src={src} type="audio/mpeg" />
        {/* No captions available — VICIdial recordings are raw audio without a transcript
            track file. Transcript text is rendered separately by <Transcript />. */}
        <track kind="captions" />
      </audio>
    )
  }
)
